









































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';
import { MedicaoPressaoArterialExcluirFormData } from '../../../../back/src/types';
import { MedicaoPressaoArterial } from '../../../../back/src/entity/MedicaoPressaoArterial';

export default Vue.extend({
  name: 'MedicaoPressaoArterialExcluirForm',
  props: {
    medicaoPressaoArterial: {
      type: Object as () => MedicaoPressaoArterial,
    },
  },
  components: {
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        justificativa: null,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório.',
        ],
      },
    };
  },
  mounted() {
  },
  computed: {
    formExcluirMedicaoPressao(): Vue & {
      validate: () => boolean,
      reset: () => void,
      } {
      return this.$refs.formExcluirMedicaoPressao as Vue & {
        validate: () => boolean,
        reset: () => void,
      };
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formExcluirMedicaoPressao.validate()) {
        this.loading = false;
        return;
      }
      const formData: MedicaoPressaoArterialExcluirFormData = {
        id: this.medicaoPressaoArterial.id,
        justificativa: this.form.justificativa,
      };
      try {
        const response = await Requester.medicaoPressaoArterial.excluiMedicao(
          this.medicaoPressaoArterial.id,
          formData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.formExcluirMedicaoPressao.reset();
          this.$emit('medicao-excluida', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Medição excluída com sucesso' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
